import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import './ShareStoryModal.css'
import { IoIosCloseCircleOutline } from 'react-icons/io';
import { Editor } from '@tinymce/tinymce-react';
import { useAuth } from '../../Context/ContextProvider';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700,
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: "8px"
};
function ShareStoryModal({ open, setOpen }) {
    const editorRef = React.useRef(null);
    // State for input fields
    const [form, setForm] = React.useState({
        name: '',
        email: '',
        title: null,
        userPicture: null,
        storyPicture: null,
        category: '',
    });
    const [storyContent, setStoryContent] = React.useState('');
    const [errors, setErrors] = React.useState({});
    const { createStory, button_loading } = useAuth();

    const handleChange = (e) => {
        const { name, value, type, files } = e.target;
        if (type === 'file') {
            setForm(prev => ({ ...prev, [name]: files[0] }));
        } else {
            setForm(prev => ({ ...prev, [name]: value }));
        }
    };

    const countWords = (htmlContent) => {
        if (!htmlContent || htmlContent === '<p></p>') return 0;
        // Create a temporary div to parse HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlContent;
        // Get text content and count words
        const text = tempDiv.textContent || tempDiv.innerText || '';
        return text.trim().split(/\s+/).filter(word => word.length > 0).length;
    };

    const validate = () => {
        const newErrors = {};
        if (!form.name) newErrors.name = 'Name is required';
        if (!form.email) newErrors.email = 'Email is required';
        else if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.email)) newErrors.email = 'Email is invalid';
        // if (!form.storyPicture) newErrors.storyPicture = 'Picture about story is required';
        if (!form.category) newErrors.category = 'Category is required';
        if (!storyContent || storyContent === '<p></p>') {
            newErrors.storyContent = 'Story is required';
        } else {
            const wordCount = countWords(storyContent);
            if (wordCount > 50) {
                newErrors.storyContent = 'Story should not exceed 50 words';
            }
        }
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const v = validate();
        setErrors(v);
        if (Object.keys(v).length === 0) {
            const data = {
                ...form,
                storyContent,
            };
            const res = await createStory(data);
            if (res.success) {
                // Optionally show toast here
                setOpen(false);
            } else {
                // Optionally show error feedback/toast here
                console.error(res.error || 'Error submitting story');
            }
        }
    };
    const handleClose = () => setOpen(false);
    React.useEffect(() => {
let innerWidth = window.innerWidth;
if(innerWidth < 768){
    style.width = '90%';
}
    },[window.innerWidth])
    return (
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div className='story_modal_box'>
                        <div className='header_modal'>
                            <h6 className='m-0'>Share your Story</h6>
                            <button onClick={handleClose}><IoIosCloseCircleOutline /></button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className='row m-0'>
                                <div className='col-12 col-md-6 p-0 p-md-2'>
                                    <div className='inp_box'>
                                        <label>Name<span className='text-danger'>*</span></label>
                                        <input name="name" value={form.name} onChange={handleChange} placeholder='Name' />
                                        {errors.name && <div className='text-danger'>{errors.name}</div>}
                                    </div>
                                </div>
                                <div className='col-12 col-md-6 p-0 p-md-2'>
                                    <div className='inp_box'>
                                        <label>Email<span className='text-danger'>*</span></label>
                                        <input name="email" value={form.email} onChange={handleChange} placeholder='Email' />
                                        {errors.email && <div className='text-danger'>{errors.email}</div>}
                                    </div>
                                </div>
                       
                                <div className='col-12 col-md-6 p-0 p-md-2'>
                                    <div className='inp_box'>
                                        <label>Your Picture</label>
                                        <input type='file' name="userPicture" onChange={handleChange} style={{padding: ".3rem 1rem"}}/>
                                    </div>
                                </div>
                                {/* <div className='col-12 col-md-6 p-0 p-md-2'>
                                    <div className='inp_box'>
                                        <label>Picture About Story<span className='text-danger'>*</span></label>
                                        <input type='file' name="storyPicture" onChange={handleChange} style={{padding: ".3rem 1rem"}}/>
                                        {errors.storyPicture && <div className='text-danger'>{errors.storyPicture}</div>}
                                    </div>
                                </div> */}
                                <div className='col-12 col-md-6 p-0 p-md-2'>
                                    <div className='inp_box'>
                                        <label>Affiliation<span className='text-danger'>*</span></label>
                                        <input name="category" value={form.category} onChange={handleChange} placeholder='WriteCategory' />
                                        {errors.category && <div className='text-danger'>{errors.category}</div>}
                                    </div>
                                </div>
                                <div className='col-12 col-md-12 p-0 p-md-2         '>
                                    <div className='inp_box'>
                                        <label>Write Your Story<span className='text-danger'>*</span></label>
                                        <Editor
                                            apiKey='eikrqf8ajju325rkzuzja23u5yqoduvs5s5ur4v3er9h53t9'
                                            onInit={(evt, editor) => editorRef.current = editor}
                                            value={storyContent}
                                            initialValue="<p>This is the initial content of the editor.</p>"
                                            onEditorChange={setStoryContent}
                                            init={{
                                                height: 300,
                                                menubar: false,
                                                plugins: [
                                                    'advlist autolink lists link image charmap print preview anchor',
                                                    'searchreplace visualblocks code fullscreen',
                                                    'insertdatetime media table paste code help wordcount'
                                                ],
                                                toolbar: 'undo redo | formatselect | ' +
                                                    'bold italic backcolor | alignleft aligncenter ' +
                                                    'alignright alignjustify | bullist numlist outdent indent | ' +
                                                    'removeformat | help',
                                                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                                            }}
                                        />
                                        {errors.storyContent && <div className='text-danger'>{errors.storyContent}</div>}
                                    </div>
                                </div>
                            </div>
                            <div className='modal_bottom'>
                                <button type='button' onClick={handleClose} className='cancel_btn'>Cancel</button>
                                <button type='submit' className='submit_btn' disabled={button_loading}>{button_loading ? 'Submitting...' : 'Submit'}</button>
                            </div>
                        </form>
                    </div>
                </Box>
            </Modal>
    )
}

export default ShareStoryModal